module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "flex-grid a-form-inputs"
  }, [_c('form', {
    staticClass: "m-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('div', {
    staticClass: "flex-grid__item"
  }, [(_vm.showNames) ? _c('control', {
    attrs: {
      "label": "Deceased Name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.theDeceased.name),
      expression: "theDeceased.name"
    }, {
      name: "field-control",
      rawName: "v-field-control:deceased_name.required",
      value: ({
        type: 'text',
        rules: 'name'
      }),
      expression: "{type:'text', rules:'name'}",
      arg: "deceased_name",
      modifiers: {
        "required": true
      }
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "name": "deceased_name",
      "maxlength": "100",
      "type": "text"
    },
    domProps: {
      "value": (_vm.theDeceased.name)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.theDeceased, "name", $event.target.value)
      }, _vm.update]
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_name')
    }
  }, [_vm._v("\n                        The deceased's name is required and must be a valid name\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_gender",
      "label": "Deceased Gender"
    }
  }, [_c('select', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.theDeceased.gender),
      expression: "theDeceased.gender"
    }],
    attrs: {
      "required": "",
      "name": "deceased_gender"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.theDeceased, "gender", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.update]
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Please select...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_gender')
    }
  }, [_vm._v("\n                        The deceased's gender is required\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_date_of_birth",
      "label": "Deceased Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:deceased_date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "deceased_date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.theDeceased.dateOfBirth),
      callback: function($$v) {
        _vm.$set(_vm.theDeceased, "dateOfBirth", $$v)
      },
      expression: "theDeceased.dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_date_of_birth') || !_vm.validDateOfBirth()
    }
  }, [_vm._v("\n                        The deceased's date of birth is required and must be in the format DD/MM/YYYY\n                        and be at least the age of 18\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "onset_of_deceased_symptoms",
      "label": _vm.claimDetailsValue('diseaseOrAccident') === 'disease' ? 'Onset of Symptoms' : 'Date of Injury / Accident'
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:onset_of_deceased_symptoms.required",
      value: ({
        type: 'date',
        rules: 'min:' + _vm.theDeceased.dateOfBirth + '|' + 'max:' + _vm.theDeceased.dateOfDeath
      }),
      expression: "{type:'date', rules:'min:'+theDeceased.dateOfBirth +'|'+'max:'+theDeceased.dateOfDeath}",
      arg: "onset_of_deceased_symptoms",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.theDeceased.onsetOfSymptoms),
      callback: function($$v) {
        _vm.$set(_vm.theDeceased, "onsetOfSymptoms", $$v)
      },
      expression: "theDeceased.onsetOfSymptoms"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('onset_of_deceased_symptoms') || !_vm.validOnsetOfSymptoms()
    }
  }, [_vm._v("\n                        The onset of symptoms is required, it must be in the format DD/MM/YYYY and be before the\n                        date of death and after the date of birth\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_date_of_death",
      "label": "Deceased Date of Death"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:deceased_date_of_death.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "deceased_date_of_death",
      modifiers: {
        "required": true
      }
    }],
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.theDeceased.dateOfDeath),
      callback: function($$v) {
        _vm.$set(_vm.theDeceased, "dateOfDeath", $$v)
      },
      expression: "theDeceased.dateOfDeath"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_date_of_death')
    }
  }, [_vm._v("\n                        The deceased's date of death is required, must be in the format DD/MM/YYYY and must be\n                        within 9 years of the assessment date\n                        (" + _vm._s(_vm.assumedSettlement) + ")\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfDeath()
    }
  }, [_vm._v("\n                        The deceased's date of death must be within 9 years of the assessment date\n                        (" + _vm._s(_vm.assumedSettlement) + ")\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfDeathDurtaion()
    }
  }, [_vm._v("\n                        The deceased's date of death must within 9 years of the assumed settlement\n                        (" + _vm._s(_vm.assumedSettlement) + ")\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfDeathCurrent()
    }
  }, [_vm._v("\n                        The deceased's date of death must be in the past\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfProceedings()
    }
  }, [_vm._v("\n                        The deceased's date of death must be before the issue of proceedings\n                        (" + _vm._s(_vm.dateOfServiceProceedings) + ")\n                    ")]), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": !_vm.validDateOfDeathOnsetOfSymptoms()
    }
  }, [_vm._v("\n                        The deceased's date of death must be after the onset of symptoms\n                    ")])], 1), _vm._v(" "), _c('life-expectancy', {
    attrs: {
      "label": "Deceased's 'But For'",
      "person": _vm.theDeceased,
      "stepValid": _vm.$valid() && _vm.validateDateOfDeath(),
      "assumed-settlement": _vm.assumedSettlement,
      "type": 'deceased'
    },
    on: {
      "update": _vm.updateLife
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-grid__item flex-grid--space-left"
  }, [_c('control', {
    attrs: {
      "label": "Period Between Onset and Date of Death",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    staticClass: "disabled",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": _vm.periodBetweenOnsetAndDod
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_at_death",
      "label": "Deceased Age at Death",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:age_at_death",
      arg: "age_at_death"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "age_at_death",
      "type": "number",
      "name": "age_at_death",
      "min": "18"
    },
    domProps: {
      "value": _vm.theDeceased.ageAtDeath
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('age_at_death')
    }
  }, [_vm._v("\n                        The deceased must have been at least 18 years old at the time of death\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Period Between Deceased's DOD & Settlement",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "name": "deceased_and_settlement",
      "type": "number",
      "min": "0",
      "readonly": "",
      "disabled": ""
    },
    domProps: {
      "value": _vm.periodDeathToSettlement
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Deceased's Age at Assumed Settlement",
      "tip-side": "left",
      "before-after": "years-old"
    }
  }, [_c('input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "min": "0",
      "disabled": ""
    },
    domProps: {
      "value": _vm.ageAtSettlement
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.periodDeathToSettlement < 0
    }
  }, [_vm._v("\n                        Date of assessment/trial must be after the date of death\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Reduction in Deceased's Life Expectancy",
      "before-after": "years"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    staticClass: "disabled",
    attrs: {
      "autocomplete": "off",
      "type": "number",
      "disabled": ""
    },
    domProps: {
      "value": _vm.reductionInLifeExpectancy
    }
  })])], 1)])]), _vm._v(" "), _c('step-button', {
    attrs: {
      "next-valid": _vm.$valid() && _vm.validateDateOfDeath()
    }
  }), _vm._v(" "), _c('modal', {
    attrs: {
      "name": 'educationAttainment_' + _vm.uniqueId,
      "no-default-button": "true"
    }
  }, [_c('modal-content')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ecca1522!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/fatal-accident-claims/estate/steps/TheDeceased.vue
// module id = 1833
// module chunks = 0